import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const quickReorderIcon = () => (
  <svg
    width="28"
    height="24"
    viewBox="0 0 28 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.292969 23.834V21.2507H6.7513V18.6673H1.58464V16.084H6.7513V13.5007H2.94089V10.9173H6.7513V7.1069L4.23255 1.6819L6.55755 0.583984L9.59297 7.04232H24.5763L22.0576 1.6819L24.3826 0.583984L27.418 7.04232V23.834H0.292969ZM14.5013 14.7923H19.668C20.0339 14.7923 20.3407 14.6685 20.5883 14.421C20.8359 14.1734 20.9596 13.8666 20.9596 13.5007C20.9596 13.1347 20.8359 12.8279 20.5883 12.5803C20.3407 12.3328 20.0339 12.209 19.668 12.209H14.5013C14.1353 12.209 13.8286 12.3328 13.581 12.5803C13.3334 12.8279 13.2096 13.1347 13.2096 13.5007C13.2096 13.8666 13.3334 14.1734 13.581 14.421C13.8286 14.6685 14.1353 14.7923 14.5013 14.7923ZM9.33463 21.2507H24.8346V9.62565H9.33463V21.2507Z"
      fill="white"
    />
  </svg>
);

export const QuickReorderIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={quickReorderIcon} {...props} />
);
